import axios from "axios";
import Config from "../consts/config";
import {
  setToken,
  setToken_type,
  setRefreshToken,
  setUser,
  getRefreshToken,
} from "../utils/cookieAuth";

const config = {
  headers: {
    accept: "application/json",
    // 'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
};

const signInApi = {
  login: (data) => {
    return new Promise(function (resolve, reject) {
      console.log(Config.API_URL);
      axios
        .post(Config.API_URL + "auth/login", data, config)
        .then((response) => {
          if (response?.status === 200) {
            setToken(response.data.tokens.access.token);
            setRefreshToken(response.data.tokens.refresh.token);
            setUser(JSON.stringify(response.data.user));
            setToken_type("Bearer");
            localStorage.setItem(
              "permissions",
              JSON.stringify(response.data.permissions)
            );
          }
          resolve(response);
        })
        .catch((e) => {
          console.log(e, "Error login to api");
          reject(e);
        });
    });
  },

  logout: () => {
    const data = {
      refreshToken: getRefreshToken(),
    };
    return new Promise(function (resolve, reject) {
      axios
        .post(Config.API_URL + "auth/logout", data, config)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          // console.log(e, "Error logout to api");
          reject(e);
        });
    });
  },
};
export default signInApi;
